export const topCookie = ["Chocolate Chip", "Cookies and cream", "Peanut Butter", "Funfetti", "Red Velvet", "Snickerdoodle", "White Chocolate", " Macadamia"]